import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const EducatoareHome = () => {
  const { user } = useAuth();

  return (
    <div>
      <div className="page-header">
        <h1>Bine ai venit, {user?.nume}! 👋</h1>
        <p>Gestionează comenzile pentru clasa ta</p>
      </div>

      <div className="info-card">
        <h3>📍 Clasa ta</h3>
        <p><strong>Grădiniță:</strong> {user?.clasa?.numeGradinita}</p>
        <p><strong>Clasă:</strong> {user?.clasa?.numeClasa}</p>
        <p><strong>Număr copii:</strong> {user?.clasa?.numarCopii}</p>
      </div>

      <div className="card">
        <div className="card-header">Acțiuni Rapide</div>
        <div className="quick-actions">
          <Link to="/educatoare/comanda-noua" className="action-btn primary">
            <span className="icon">➕</span>
            <div>Comandă Nouă</div>
          </Link>
          <Link to="/educatoare/comenzile-mele" className="action-btn secondary">
            <span className="icon">📋</span>
            <div>Comenzile Mele</div>
          </Link>
        </div>
      </div>

      <div className="card" style={{marginTop: '24px'}}>
        <div className="card-header">Cum funcționează?</div>
        <ol style={{paddingLeft: '20px', lineHeight: '1.8'}}>
          <li>Accesează secțiunea "Comandă Nouă"</li>
          <li>Alege data pentru care dorești să comanzi</li>
          <li>Selectează felurile de mâncare din meniu</li>
          <li>Specifică numărul de porții pentru fiecare fel</li>
          <li>Adaugă observații dacă este necesar (alergii, preferințe)</li>
          <li>Plasează comanda - aceasta va fi vizibilă pentru administrator</li>
          <li>Monitorizează statusul comenzii în "Comenzile Mele"</li>
        </ol>
      </div>
    </div>
  );
};

export default EducatoareHome;
